var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.moduleId,{tag:"component",on:{"menuChange":_vm.menuChange,"itemClick":_vm.itemClick,"setMainContent":_vm.setMainContent}})}
var staticRenderFns = []

export { render, staticRenderFns }